import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import dateFormat from "dateformat";
import { utcToLocal } from "../../../helpers/DateHelper";
import { useNavigate } from "react-router-dom"; // import useNavigate
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function ContactTable({
  module,
  data,
  loading,
  totalRows,
  page,
  limit,
  fetchData,
  openUpdateModal,
  openDeleteModal,
  handleView,
  isTrash,
}) {
  const navigate = useNavigate(); // Initialize useNavigate
  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{ ((page -1 ) * limit) + index +1 }.</div>,
      width: '100px'
    },
    {
      name: "POC Name",
      selector: (row) => row.contact_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Client",
      selector: (row) => row.client_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Contact",
      selector: (row) => row.contact_mobile,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Email",
      selector: (row) => row.contact_email,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Designation",
      selector: (row) => row.contact_designation,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Last Contacted",
      selector: (row) => row.contact_last_contacted && row.contact_last_contacted != '0000-00-00' ? dateFormat(row.contact_last_contacted, 'dd/mm/yyyy') : '',
      sortable: true, // ✅ enable sorting
    },
    // {
    //   name: "Last Edited On",
    //   selector: (row) => utcToLocal(row.contact_update_time)
    // }
  ];

  if (! isTrash && (checkPermission(module.route, 'edit') || checkPermission(module.route, 'delete'))) {
    columns.push({
      name: "Action",
      right: "true",
      cell: row => <div className="hstack gap-2 fs-15">
                    {checkPermission(module.route, 'edit') && <button type="button" className="btn btn-icon btn-sm btn-info" title="Edit" onClick={() => navigate(`/contacts/${row.contact_unique_id}/edit`)}>
                      <i className='bx bxs-edit'></i>
                    </button>}

                    {checkPermission(module.route, 'delete') && <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete" onClick={() => openDeleteModal(row)}>
                      <i className='bx bxs-trash'></i>
                    </button>}
                  </div>
    });
  }

  if (isTrash) {
    columns.push({
      name: "Deleted At",
      selector: (row) => utcToLocal(row.contact_delete_time)
    });
  }

  const { theme, toggleTheme } = useTheme();

  const handlePageChange = async (page) => {
    fetchData(limit, page);
  };

  const handleLimitChange = async (newLimit, page) => {
    //if ((newLimit !== 10 && page !== 1) || localStorage.getItem(module.key)) {
      fetchData(newLimit, page);
    //}
  };

  // useEffect(() => {
  //   fetchData(limit, page);
  // }, []);

  createTheme("dark", {
    text: {
      primary: "#a2a3a4",
      secondary: "#2aa198",
    },
    background: {
      default: "#252729",
    },
    context: {
      background: "#cb4b16",
      text: "#a2a3a4",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  return (
    <DataTable
      // title={`Manage Notes (Private)`}
      className="clickable cms-data-table"
      //onRowClicked={(row) => handleView(row)}
      onRowClicked={(row) =>navigate(`/contacts/${row.contact_unique_id}/view`)}
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handleLimitChange}
      onChangePage={handlePageChange}
      progressPending={loading}
      progressComponent={<TableLoader noOfColumn={columns.length} />}
      fixedHeader
      fixedHeaderScrollHeight="550px"
      highlightOnHover
      paginationPerPage={10}  // default page size
      paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
      theme={`${theme === "light" ? "light" : "dark"}`}
      customStyles={getCmsDataTableStyles(theme)}
    />
  );
};
